import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticateComponent } from '@shared/components/authenticate/authenticate.component';
import { FaqComponent } from './shared/components/faq/faq.component';
import { PagenotfoundComponent } from './shared/components/pagenotfound/pagenotfound.component';
import { PdfDisplayComponent } from './shared/components/pdf-display/pdf-display.component';
import { UnsubscribeComponent } from './shared/components/unsubscribe/unsubscribe.component';
import { HomeComponent } from '@shared/components/home/home.component';
import { environment } from '@environments/environment';

const isMaintenanceMode = environment.maintenanceMode;

const homeRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent
  },
]

const maintenanceRoutes: Routes = [
   {
    path: 'home-new',
    component: HomeComponent
  }
];

const routes: Routes = [
  ...(isMaintenanceMode ? maintenanceRoutes : homeRoutes),
  {
    path: 'login',
    component: AuthenticateComponent
  },
  {
    path: 'login/:signature',
    component: AuthenticateComponent
  },
  { path: 'link-expired', component: AuthenticateComponent },
  {
    path: 'information',
    loadComponent: () => import('./feature/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'smart-meter-consent',
    loadChildren: () => import('./feature/SmartMeterConsent/smart-meter-consent.module').then(m => m.SmartMeterConsentModule)
  },
  {
    path: 'energy-result',
    loadComponent: () => import('./feature/quotes-result/quotes-result.component').then(m => m.QuotesResultComponent)
  },
  {
    path: 'switch',
    loadChildren: () => import('./feature/switching-details/switching-details.module').then(m => m.SwitchingDetailsModule)
  },
  {
    path: 'frequently-ask-question',
    component: FaqComponent
  },
  { path: 'pdf/:pdfKey', component: PdfDisplayComponent },
  { path: 'unsubscribe', component: UnsubscribeComponent },
  { path: 'service-unavailable', component: PagenotfoundComponent },
  { path: '**', redirectTo: '/service-unavailable', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
